import "../woocommerce/index.js";

if (!("anchorName" in document.documentElement.style)) {
	import("./polyfills/css-anchor"); //dynamic import since this is conditional
}